import { render, staticRenderFns } from "./UserDefinitionSelectDialog.vue?vue&type=template&id=49b11995&scoped=true&"
import script from "./UserDefinitionSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./UserDefinitionSelectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b11995",
  null
  
)

export default component.exports